module.exports = __webpack_public_path__ + "static/media/BlogDIH.32851f37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/BlogDIH.jpg
// module id = 199
// module chunks = 0